export const fileTypeAcceptedForCertificates = ['.pem'];
